module.exports = __webpack_public_path__ + "static/Burst_7s-dd08aed1ad390d0cbf27bb6925b2145b.jpg";